module.exports = __webpack_public_path__ + "img/huojian.fc19cdc5.png";